module.exports = "https://cdn-skillquest.mathletics.com/app/170/assets/images/e226ddfb2ccd3cfa78256afc08d2ee9a.svg";